import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.isLoggedIn()) return router.parseUrl('/login');
  return auth.validateSession().pipe(map((valid) => (valid ? true : router.parseUrl('/login'))));
};

export const loginGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.isLoggedIn()) return true;
  return auth.validateSession().pipe(map((valid) => (valid ? router.parseUrl('/dashboard') : true)));
};

export const superadminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.isLoggedIn()) return router.parseUrl('/login');
  return auth.validateSession().pipe(
    map((valid) => {
      if (!valid) return router.parseUrl('/login');
      return auth.hasRole('Superadmin') ? true : router.parseUrl('/dashboard');
    })
  );
};
